import { createAPIClient } from '@shopware/api-client';
import Cookies from 'js-cookie';
import type { operations } from '@shopware/api-client/store-api-types';

export const useApiClient = () => {
    const config = useRuntimeConfig();

    const apiClient = createAPIClient<operations>({
        baseURL: config.public.shopwareEndpoint,
        accessToken: config.public.shopwareToken,
        contextToken: Cookies.get('sw-context-token'),
    });

    // Attach the hook to the client instance
    apiClient.hook('onContextChanged', newContextToken => {
        Cookies.set('sw-context-token', newContextToken, {
            expires: 365, // days
            path: '/',
            sameSite: 'lax',
        });
    });

    return { apiClient };
};
